import * as React from "react";
import { forwardRef } from "react";
const SvgLineStartArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 12, viewBox: "0 0 23 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 11.7736L-5.04736e-07 6.00007L10 0.226563L10 5.00007L22 5.00007C22.5523 5.00007 23 5.44778 23 6.00007C23 6.55235 22.5523 7.00007 22 7.00007L10 7.00007L10 11.7736Z", fill: "#2B2B35" }));
const ForwardRef = forwardRef(SvgLineStartArrow);
export { ForwardRef as ReactComponent };
